export const ADDRESS = {
    lines: [
        "AddiGen Holdings Limited",
        "PO Box 384",
        "2nd Floor",
        "6 Hilgrove Street",
        "St Helier",
        "Jersey JE4 9ZH",
    ],
};

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1509391111737-9b07f052f6b6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHw0fHxlbGVjdHJpY2l0eSUyMHN1YnN0YXRpb24lMjB0cmFuc21pc3Npb24lMjB0b3dlcnMlMjBpbmZyYXN0cnVjdHVyZXxlbnwwfHx8fDE3OTA5OTY5NDB8MA&ixlib=rb-4.1.0&q=85&w=2400",
    towersDusk:
        "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2l0eSUyMHN1YnN0YXRpb24lMjB0cmFuc21pc3Npb24lMjB0b3dlcnMlMjBpbmZyYXN0cnVjdHVyZXxlbnwwfHx8fDE3OTA5OTY5NDB8MA&q=85&w=2000",
    towersGreen:
        "https://images.unsplash.com/photo-1413882353314-73389f63b6fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxlbGVjdHJpY2l0eSUyMHN1YnN0YXRpb24lMjB0cmFuc21pc3Npb24lMjB0b3dlcnMlMjBpbmZyYXN0cnVjdHVyZXxlbnwwfHx8fDE3OTA5OTY5NDB8MA&q=85&w=2000",
    plantNight:
        "https://images.unsplash.com/photo-1629447388369-760612337eff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwZW5lcmd5JTIwcGxhbnQlMjBwaXBlcyUyMGluZnJhc3RydWN0dXJlJTIwZHVza3xlbnwwfHx8fDE3OTA5OTY5NDB8MA&q=85&w=2000",
    plantDusk:
        "https://images.unsplash.com/photo-1468787737698-f5c03f0570dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwZW5lcmd5JTIwcGxhbnQlMjBwaXBlcyUyMGluZnJhc3RydWN0dXJlJTIwZHVza3xlbnwwfHx8fDE3OTA5OTY5NDB8MA&q=85&w=2000",
    factoryDark:
        "https://images.unsplash.com/photo-1511454493857-0a29f2c023c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxpbmR1c3RyaWFsJTIwZW5lcmd5JTIwcGxhbnQlMjBwaXBlcyUyMGluZnJhc3RydWN0dXJlJTIwZHVza3xlbnwwfHx8fDE3OTA5OTY5NDB8MA&q=85&w=2000",
    towerBlue:
        "https://images.unsplash.com/photo-1588011930968-eadac80e6a5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwZW5lcmd5JTIwcGxhbnQlMjBwaXBlcyUyMGluZnJhc3RydWN0dXJlJTIwZHVza3xlbnwwfHx8fDE3OTA5OTY5NDB8MA&q=85&w=2000",
    tunnel:
        "https://images.unsplash.com/photo-1495870043034-74e1a009f631?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHx1bmRlcmdyb3VuZCUyMHR1bm5lbCUyMGluZHVzdHJpYWwlMjBjb25jcmV0ZXxlbnwwfHx8fDE3OTA5OTY5NDB8MA&q=85&w=2000",
    aerialGrid:
        "https://images.unsplash.com/photo-1781816928012-307c1b27d46b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxwb3dlciUyMGxpbmVzJTIwbGFuZHNjYXBlJTIwYWVyaWFsJTIwZ3JpZHxlbnwwfHx8fDE3OTA5OTY5NDB8MA&q=85&w=2000",
    controlRoom:
        "https://images.pexels.com/photos/32845695/pexels-photo-32845695.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    controlRoom2:
        "https://images.pexels.com/photos/32845700/pexels-photo-32845700.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const NAV = [
    { label: "Home", path: "/", header: false },
    {
        label: "Company",
        path: "/company/story",
        header: true,
        mega: "company",
        children: [
            { label: "Our Story", path: "/company/story", desc: "The company and the market need behind it." },
            { label: "What Makes AddiGen Different", path: "/company/difference", desc: "Six principles of disciplined development." },
            { label: "Our Mission", path: "/company/mission", desc: "Why the platform exists." },
            { label: "Our Values", path: "/company/values", desc: "Five values, one standard of delivery." },
            { label: "Senior Leadership Team", path: "/company/leadership", desc: "The team accountable for delivery." },
            { label: "Partners & Stakeholders", path: "/company/partners", desc: "The institutions AddiGen works with." },
            { label: "FAQ", path: "/company/faq", desc: "Common questions, answered plainly." },
        ],
    },
    { label: "Technology", path: "/technology", header: true },
    { label: "Projects", path: "/projects", header: true, mega: "projects" },
    { label: "Careers", path: "/careers", header: true },
    {
        label: "News & Media",
        path: "/news",
        header: true,
        mega: "news",
        children: [
            { label: "Press Releases", path: "/news?tab=press", desc: "Official announcements from AddiGen." },
            { label: "Company News", path: "/news?tab=company", desc: "Updates from across the development platform." },
            { label: "Media Enquiries", path: "/news#media-enquiries", desc: "Reach the AddiGen team directly." },
        ],
    },
    { label: "Contact", path: "/contact", header: false },
];

export const PLATFORM_STAGES = [
    { n: "01", title: "Originate", body: "Identify early-stage energy storage opportunities across European markets." },
    { n: "02", title: "Develop", body: "Advance projects through feasibility, consenting and grid connection." },
    { n: "03", title: "De-risk", body: "Reduce technical, commercial and regulatory uncertainty step by step." },
    { n: "04", title: "Finance", body: "Structure projects to be investment-ready for institutional capital." },
    { n: "05", title: "Partner / Sell Equity", body: "Bring in long-term capital and delivery partners at the right moment." },
    { n: "06", title: "Recycle Capital", body: "Return realised capital to the development platform." },
    { n: "07", title: "Develop the Next Generation", body: "Reinvest in the next pipeline of storage infrastructure." },
];

export const WHY_CARDS = [
    {
        n: "01",
        title: "Infrastructure development capability",
        body: "Originate, develop and de-risk complex storage projects from early-stage opportunity through to investable infrastructure.",
    },
    {
        n: "02",
        title: "System-led technology approach",
        body: "Apply CAES and BESS technologies based on duration, grid need and market requirements.",
    },
    {
        n: "03",
        title: "Commercial and capital discipline",
        body: "Structure projects to support financing, partnership and long-term value creation.",
    },
    {
        n: "04",
        title: "Long-term asset ambition",
        body: "Build toward ownership and operation of storage assets that play a critical role in Europe's power system.",
    },
];

export const DIFFERENCE_CARDS = [
    {
        n: "01",
        title: "End-to-end development capability",
        body: "AddiGen manages the full development cycle — from origination through de-risking, financing and partnership.",
    },
    {
        n: "02",
        title: "Complementary technology approach",
        body: "CAES and BESS are applied where duration, grid need and market requirements make each most effective.",
    },
    {
        n: "03",
        title: "Backed by institutional capital",
        body: "Projects are structured to meet the standards of institutional investors and infrastructure funds.",
    },
    {
        n: "04",
        title: "Disciplined project selection",
        body: "Only projects that meet strict technical, commercial and regulatory criteria progress through the pipeline.",
    },
    {
        n: "05",
        title: "Capital recycling model",
        body: "Realised projects return capital to the platform to develop the next generation of storage assets.",
    },
    {
        n: "06",
        title: "Deep project knowledge",
        body: "Direct development experience across EU-designated CAES and BESS projects in Germany and Denmark.",
    },
];

export const VALUES = [
    { n: "01", title: "Integrity", body: "We do what we say — transparently, with colleagues, partners and stakeholders." },
    { n: "02", title: "Collaboration", body: "Complex infrastructure is delivered with others. We work openly with partners, authorities and communities." },
    { n: "03", title: "Accountability", body: "We own outcomes across the full development cycle, from origination to operation." },
    { n: "04", title: "Challenge", body: "We test every assumption — technical, commercial and regulatory — before capital is committed." },
    { n: "05", title: "Discipline", body: "Capital, time and expertise are deployed with discipline. Focus over volume." },
];

export const LEADERSHIP = [
    { name: "Patrick McClughan", role: "CEO & Co-Founder", initials: "PM", placeholder: false },
    { name: "Niall Savage", role: "COO & Co-Founder", initials: "NS", placeholder: false },
    { name: "To be inserted", role: "CFO", initials: "", placeholder: true },
];

export const PARTNERS = ["Energinet", "Amprion", "Gas Storage Denmark", "Siemens Energy"];

export const PARTNER_CATEGORIES = [
    {
        title: "Commercial and institutional partners",
        body: "AddiGen works with established European transmission system operators, storage operators and technology suppliers to develop bankable storage infrastructure.",
        list: ["Energinet", "Amprion", "Gas Storage Denmark", "Siemens Energy"],
    },
    {
        title: "Local and regional stakeholders",
        body: "Long-duration storage is built in partnership with the communities, authorities and network operators that host it. We engage early and maintain that engagement through every development phase.",
        list: [],
    },
];

export const PROJECTS = [
    {
        id: "ahaus-caes",
        slug: "germany-ahaus-caes",
        name: "Ahaus CAES",
        market: "Germany",
        location: "Ahaus, Germany",
        tech: "CAES",
        pci: "PCI 1.32",
        status: "In development",
        gridConnection: "To be confirmed",
        duration: "Multi-hour to multi-day",
        stats: [
            { value: "220", unit: "MW", label: "Charge capacity" },
            { value: "320", unit: "MW", label: "Discharge capacity" },
            { value: "25", unit: "GWh", label: "Storage capacity", prefix: "up to" },
        ],
        strategic:
            "Ahaus is an EU-designated Project of Common Interest (PCI 1.32), recognising its strategic contribution to Europe's trans-European energy infrastructure policy.",
        description:
            "The Ahaus CAES project will provide large-scale, long-duration energy storage in Germany, storing renewable electricity as compressed air and returning it to the grid when the system needs it most. The project is designed to absorb surplus renewable generation and discharge across multi-hour to multi-day periods.",
        technical: [
            "Compressed Air Energy Storage (CAES) facility",
            "220 MW charge capacity",
            "320 MW discharge capacity",
            "Up to 25 GWh of storage capacity",
            "Multi-hour to multi-day discharge capability",
        ],
        image: IMAGES.factoryDark,
    },
    {
        id: "germany-bess",
        slug: "germany-bess",
        name: "Germany BESS",
        market: "Germany",
        location: "Germany",
        tech: "BESS",
        pci: null,
        status: "In development",
        gridConnection: "To be confirmed",
        duration: "4-hour",
        stats: [
            { value: "180", unit: "MW", label: "Charge capacity" },
            { value: "180", unit: "MW", label: "Discharge capacity" },
            { value: "720", unit: "MWh", label: "Storage capacity", prefix: "up to" },
        ],
        strategic:
            "The German BESS portfolio provides fast-response flexibility that complements the long-duration capability of the Ahaus CAES project, addressing grid services and shorter-duration balancing needs.",
        description:
            "The German BESS development delivers grid-scale battery storage with fast response capability, providing the shorter-duration flexibility the German power system requires as renewable generation continues to grow.",
        technical: [
            "Battery Energy Storage System (BESS)",
            "180 MW charge capacity",
            "180 MW discharge capacity",
            "4-hour duration",
            "Up to 720 MWh of storage capacity",
        ],
        image: IMAGES.towerBlue,
    },
    {
        id: "ghh-caes",
        slug: "denmark-green-hydrogen-hub-caes",
        name: "Green Hydrogen Hub CAES",
        market: "Denmark",
        location: "Denmark",
        tech: "CAES",
        pci: "PCI 1.16",
        status: "In development",
        gridConnection: "To be confirmed",
        duration: "Multi-hour to multi-day",
        stats: [
            { value: "110", unit: "MW", label: "Charge capacity" },
            { value: "160", unit: "MW", label: "Discharge capacity" },
            { value: "9", unit: "GWh", label: "Storage capacity", prefix: "up to" },
        ],
        strategic:
            "The Green Hydrogen Hub is an EU-designated Project of Common Interest (PCI 1.16), recognising its strategic contribution to Europe's trans-European energy infrastructure policy.",
        description:
            "The Green Hydrogen Hub CAES project will provide long-duration energy storage in Denmark, storing electricity as compressed air and discharging it across extended periods to support system resilience as renewable generation grows.",
        technical: [
            "Compressed Air Energy Storage (CAES) facility",
            "110 MW charge capacity",
            "160 MW discharge capacity",
            "Up to 9 GWh of storage capacity",
            "Multi-hour to multi-day discharge capability",
        ],
        image: IMAGES.tunnel,
    },
    {
        id: "denmark-bess",
        slug: "denmark-bess",
        name: "Denmark BESS",
        market: "Denmark",
        location: "Denmark",
        tech: "BESS",
        pci: null,
        status: "In development",
        gridConnection: "To be confirmed",
        duration: "4-hour",
        stats: [
            { value: "160", unit: "MW", label: "Charge capacity" },
            { value: "160", unit: "MW", label: "Discharge capacity" },
            { value: "640", unit: "MWh", label: "Storage capacity", prefix: "up to" },
        ],
        strategic:
            "The Danish BESS development complements the Green Hydrogen Hub CAES project with fast-response grid services and shorter-duration flexibility in the Danish market.",
        description:
            "The Danish BESS development delivers grid-scale battery storage for the Danish market, providing fast-responding flexibility alongside the long-duration capability of the Green Hydrogen Hub CAES project.",
        technical: [
            "Battery Energy Storage System (BESS)",
            "160 MW charge capacity",
            "160 MW discharge capacity",
            "4-hour duration",
            "Up to 640 MWh of storage capacity",
        ],
        image: IMAGES.plantDusk,
    },
];

export const MEGA = {
    company: {
        eyebrow: "Company",
        title: "The developer behind Europe's long-duration storage.",
        desc: "Who AddiGen is, how the platform works, and the principles behind every project.",
        links: NAV.find((n) => n.mega === "company").children,
        featuredList: [
            {
                eyebrow: "Our Mission",
                title: "Developing large-scale CAES and BESS projects to support Europe's decarbonisation and renewable energy targets.",
                to: "/company/mission",
                cta: "Read our mission",
            },
            {
                eyebrow: "Projects of Common Interest",
                title: "2 EU-designated PCIs — Ahaus (PCI 1.32) and Green Hydrogen Hub (PCI 1.16).",
                to: "/projects",
                cta: "View the projects",
            },
            {
                eyebrow: "Development platform",
                title: "Originate, develop, de-risk, finance, partner, recycle capital — then develop the next generation.",
                to: "/",
                cta: "See the platform",
            },
        ],
    },
    projects: {
        eyebrow: "Projects",
        title: "Infrastructure-scale storage across two markets.",
        desc: "Four storage developments in Germany and Denmark, built on one standard of discipline.",
        links: [
            { label: "All projects", path: "/projects", desc: "The full development portfolio." },
            ...PROJECTS.map((p) => ({
                label: p.name,
                path: `/projects/${p.slug}`,
                desc: `${p.tech} · ${p.market}${p.pci ? ` · ${p.pci}` : ""} · ${p.stats
                    .map((s) => `${s.prefix ? s.prefix + " " : ""}${s.value} ${s.unit}`)
                    .join(" / ")}`,
            })),
        ],
        featuredList: [
            {
                eyebrow: "Featured project — PCI 1.32",
                title: "Ahaus CAES, Germany. 220 MW charge, 320 MW discharge, up to 25 GWh storage.",
                body: "Target figures, subject to final investment decision.",
                to: "/projects/germany-ahaus-caes",
                cta: "View project",
            },
            {
                eyebrow: "Featured project — PCI 1.16",
                title: "Green Hydrogen Hub CAES, Denmark. 110 MW charge, 160 MW discharge, up to 9 GWh storage.",
                body: "Target figures, subject to final investment decision.",
                to: "/projects/denmark-green-hydrogen-hub-caes",
                cta: "View project",
            },
            {
                eyebrow: "Grid-scale batteries",
                title: "Germany and Denmark BESS — 4-hour duration, up to 720 and 640 MWh.",
                body: "Target figures, subject to final investment decision.",
                to: "/projects",
                cta: "View all projects",
            },
        ],
    },
    news: {
        eyebrow: "News & Media",
        title: "Statements, updates and media enquiries.",
        desc: "What AddiGen publishes, and how to reach the team on the record.",
        links: [
            { label: "All News & Media", path: "/news", desc: "The full newsroom." },
            ...NAV.find((n) => n.mega === "news").children,
        ],
        featuredList: [
            {
                eyebrow: "Media enquiries",
                title: "media@addigen.com",
                body: "We respond to enquiries with a stated deadline as a priority.",
                to: "/news#media-enquiries",
                cta: "Go to media enquiries",
            },
            {
                eyebrow: "Press releases",
                title: "Official AddiGen announcements will be published here.",
                to: "/news?tab=press",
                cta: "Go to press releases",
            },
        ],
    },
};

export const SEARCH_INDEX = [
    { title: "Home", path: "/", type: "Page", excerpt: "Europe's long-duration energy storage developer." },
    { title: "Our Story", path: "/company/story", type: "Company", excerpt: "The company and the market need behind it." },
    { title: "What Makes AddiGen Different", path: "/company/difference", type: "Company", excerpt: "Six principles of disciplined development." },
    { title: "Our Mission", path: "/company/mission", type: "Company", excerpt: "Developing large-scale CAES and BESS projects to support Europe's decarbonisation and renewable energy targets." },
    { title: "Our Values", path: "/company/values", type: "Company", excerpt: "Integrity, collaboration, accountability, challenge, discipline.", keywords: "integrity collaboration accountability challenge discipline" },
    { title: "Senior Leadership Team", path: "/company/leadership", type: "Company", excerpt: "Patrick McClughan, CEO & Co-Founder. Niall Savage, COO & Co-Founder.", keywords: "CEO COO CFO leadership founders team" },
    { title: "Partners & Stakeholders", path: "/company/partners", type: "Company", excerpt: "Energinet, Amprion, Gas Storage Denmark, Siemens Energy.", keywords: "energinet amprion gas storage denmark siemens energy TSO partners" },
    { title: "FAQ", path: "/company/faq", type: "Company", excerpt: "About AddiGen and about energy storage." },
    { title: "Technology", path: "/technology", type: "Technology", excerpt: "Proven technology, disciplined deployment. CAES and BESS.", keywords: "BESS battery compressed air" },
    { title: "How CAES works", path: "/technology", type: "Technology", excerpt: "Compress. Store. Expand. Return. The Compressed Air Energy Storage process." },
    { title: "Diabatic and adiabatic CAES", path: "/technology", type: "Technology", excerpt: "What happens to the heat defines the variant." },
    { title: "Projects", path: "/projects", type: "Projects", excerpt: "Developing infrastructure-scale energy storage in Germany and Denmark." },
    { title: "Ahaus CAES — Germany", path: "/projects/germany-ahaus-caes", type: "Project", excerpt: "PCI 1.32. 220 MW charge, 320 MW discharge, up to 25 GWh storage.", keywords: "germany cavern long duration" },
    { title: "Germany BESS", path: "/projects/germany-bess", type: "Project", excerpt: "180 MW charge, 180 MW discharge, 4-hour duration, up to 720 MWh.", keywords: "battery germany" },
    { title: "Green Hydrogen Hub CAES — Denmark", path: "/projects/denmark-green-hydrogen-hub-caes", type: "Project", excerpt: "PCI 1.16. 110 MW charge, 160 MW discharge, up to 9 GWh storage.", keywords: "denmark cavern hydrogen long duration" },
    { title: "Denmark BESS", path: "/projects/denmark-bess", type: "Project", excerpt: "160 MW charge, 160 MW discharge, 4-hour duration, up to 640 MWh.", keywords: "battery denmark" },
    { title: "Careers", path: "/careers", type: "Careers", excerpt: "Why join AddiGen. Open positions and applications.", keywords: "jobs vacancies apply" },
    { title: "News & Media", path: "/news", type: "News", excerpt: "Press releases, company news and media enquiries." },
    { title: "Media enquiries", path: "/news#media-enquiries", type: "News", excerpt: "media@addigen.com", keywords: "press journalist press@ interview" },
    { title: "Contact", path: "/contact", type: "Contact", excerpt: "Let's discuss the infrastructure behind Europe's energy transition.", keywords: "enquiry investment partnership grid regulatory office jersey" },
    { title: "Privacy Policy", path: "/privacy", type: "Legal", excerpt: "How AddiGen handles personal data." },
    { title: "Cookie Policy", path: "/cookies", type: "Legal", excerpt: "Cookies used on this website." },
    { title: "Terms of Use", path: "/terms", type: "Legal", excerpt: "Terms governing use of this website." },
    { title: "Sitemap", path: "/sitemap", type: "Page", excerpt: "Every page, one place." },
];

export const FID_NOTE = "All capacity figures are target figures and subject to final investment decision.";

export const MARKETS = [
    {
        country: "Germany",
        image: IMAGES.towersDusk,
        projects: PROJECTS.filter((p) => p.market === "Germany"),
    },
    {
        country: "Denmark",
        image: IMAGES.towersGreen,
        projects: PROJECTS.filter((p) => p.market === "Denmark"),
    },
];

export const FAQS = {
    about: [
        {
            q: "What does AddiGen do?",
            a: "AddiGen is a European long-duration energy storage infrastructure developer. We originate, develop and de-risk large-scale Compressed Air Energy Storage (CAES) and Battery Energy Storage System (BESS) projects in European energy markets, building toward long-term ownership and operation of storage infrastructure.",
        },
        {
            q: "Where does AddiGen operate?",
            a: "AddiGen is currently developing projects in two European markets — Germany and Denmark — including two EU-designated Projects of Common Interest: the Ahaus CAES project in Germany (PCI 1.32) and the Green Hydrogen Hub CAES project in Denmark (PCI 1.16).",
        },
        {
            q: "Is AddiGen a technology manufacturer?",
            a: "No. AddiGen is an infrastructure developer, not a technology vendor. We apply proven storage technologies — CAES and BESS — based on duration, grid need and market requirements.",
        },
        {
            q: "What is a Project of Common Interest?",
            a: "Projects of Common Interest are infrastructure projects designated by the European Union as essential for achieving Europe's energy infrastructure objectives. PCI status recognises a project's strategic contribution to the trans-European energy system.",
        },
        {
            q: "Who leads AddiGen?",
            a: "AddiGen is led by CEO and Co-Founder Patrick McClughan and COO and Co-Founder Niall Savage. The position of Chief Financial Officer will be announced in due course.",
        },
    ],
    storage: [
        {
            q: "What is long-duration energy storage?",
            a: "Long-duration energy storage refers to storage systems that can discharge electricity over multi-hour to multi-day periods. It complements short-duration batteries by keeping power available across extended periods of low renewable generation.",
        },
        {
            q: "What is CAES?",
            a: "Compressed Air Energy Storage (CAES) uses electricity to compress air and store it — typically underground. When the power system needs energy, the compressed air is released through an expansion stage to generate electricity and return it to the grid.",
        },
        {
            q: "What is BESS?",
            a: "Battery Energy Storage Systems (BESS) store electricity directly in batteries and respond within seconds. They provide fast-response flexibility and grid services over shorter durations.",
        },
        {
            q: "How do CAES and BESS differ?",
            a: "BESS provides shorter-duration flexibility, fast response and grid services. CAES provides long-duration storage with multi-hour to multi-day capability and system resilience. AddiGen deploys both, based on duration, grid need and market requirements.",
        },
        {
            q: "Why does Europe need long-duration storage?",
            a: "As Europe decarbonises its power system and renewable generation grows, the grid increasingly needs large-scale storage that can shift energy across extended periods. Long-duration storage supports Europe's decarbonisation and renewable energy targets.",
        },
    ],
};

export const ENQUIRY_TYPES = ["Investment", "Partnership", "Grid & Regulatory", "Other"];

export const MEDIA_NATURES = [
    "General media enquiry",
    "Press release request",
    "Interview request",
    "Project information",
    "Other",
];

export const MEDIA_EMAIL = "media@addigen.com";
